import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const Homepage = Scrivito.provideObjClass("Homepage", {
  attributes: {
    ...defaultPageAttributes,
    childOrder: "referencelist",
    cookieConsentLink: "link",
    dividerLogo: ["reference", { only: ["Image"] }],
    facebookAppId: "string",
    footerWidgets: ["widgetlist", { only: "FooterContainerWidget" }],
    googleMapsApiKey: "string",
    navigationFooterLinks: "linklist",
    minimizedFooterLinks: "linklist",
    navigationServiceLinks: "linklist",
    commercialOfferLinks: "linklist",
    configuratorNavigationServiceLinks: [
      "referencelist",
      {
        only: [
          "Homepage",
          "ProjectList",
          "ContentPage",
          "Redirect",
          "ConfiguratorSupport",
        ],
      }, // TODO: "Redirect" is only temporary (for ISH presentation)
    ],
    configuratorNavTitle: "string",
    configuratorNavMenu: "string",
    configuratorNavLogin: "string",
    configuratorNavExit: "string",
    projectItemPage: ["reference", { only: ["ProjectItem"] }],
    projectConfiguratorPage: ["reference", { only: ["ProjectConfigurator"] }],
    productConfiguratorPage: ["reference", { only: ["ProductConfigurator"] }],
    productListPage: ["reference", { only: ["ProductList"] }],
    configLeftSidebarProjectRefs: [
      "referencelist",
      {
        only: ["ProjectList", "ProjectItem", "ProjectConfigurator"],
      },
    ],
    configLeftSidebarProductsRefs: [
      "referencelist",
      {
        only: ["ProductConfigurator", "ProductList", "CustomProductItem"],
      },
    ],
    configWizardObjRefs: [
      "referencelist",
      {
        only: ["WizardList", "Wizard", "Redirect"], // TODO: "Redirect" is only temporary (for ISH presentation)
      },
    ],
    configLeftSidebarLibraryRefs: [
      "referencelist",
      {
        only: ["LibraryList", "LibraryTemplates", "LibraryCustom"],
      },
    ],
    configLeftSidebarHelpRefs: ["referencelist", { only: ["ContentPage"] }],
    welcomePage: ["reference", { only: ["ContentPage"] }],
    logo: ["reference", { only: ["Image"] }],
    logoLink: "link",
    configuratorLogo: ["reference", { only: ["Image"] }],
    twitterSite: "string",
    mainNavigationSerialized: "string",
    ...metadataAttributes,
  },
  extractTextAttributes: [],
});

export default Homepage;
